namespace $.$$ {
	export class $shm_hitalama_map_widget_float_customizer extends $.$shm_hitalama_map_widget_float_customizer {

		@ $mol_mem
		title( next?: string ): string {
			return this.widget().Custom()?.remote()?.title( next ) ?? ''
		}
		
		@ $mol_mem
		code_js( next?: string ): string {
			return this.widget().Custom()?.remote()?.source_text( 'logic', next ) ?? ''
		}

		@ $mol_mem
		code_view_tree( next?: string ): string {
			return this.widget().Custom()?.remote()?.source_text( 'tree', next ) ?? ''
		}

		@ $mol_mem
		code_css( next?: string ): string {
			return this.widget().Custom()?.remote()?.source_text( 'style', next ) ?? ''
		}

		@ $mol_mem
		fqn( next?: string ): string { return next ?? this.widget().Custom()?.remote()?.class_name() ?? '' }

		@ $mol_action
		rename() { this.widget().Custom()?.remote()?.rename( this.fqn().trim() ) }
		rename_enabled() {
			const definition = this.widget().Custom()?.remote()
			return definition?.source_format() === 'ts' && !definition.Owner_catalog()?.remote()
		}
		definition_link() { return this.widget().Custom()?.remote()?.link().str ?? '' }
		logic_title() { return this.widget().Custom()?.remote()?.source_format() === 'ts' ? 'TS' : 'JS (старый формат)' }
		style_title() { return this.widget().Custom()?.remote()?.source_format() === 'ts' ? 'Стили TS' : 'CSS' }

		dependencies_text( next?: string ) {
			return this.widget().Custom()?.remote()?.Dependencies( next )?.val( next ) ?? ''
		}

		@ $mol_mem
		visible_in_menu( next?: boolean ): boolean {
			return this.widget().Custom()?.remote()?.Visible_in_contextmenu( next )?.val( next ) ?? false
		}

		create_instance( event?: Event | null ) {
			if( event ) return $shm_hitalama_map_event_once( event, 'component-instance', ()=>
				this.create_instance_command( $shm_hitalama_map_event_key( event, 'component-instance' ) ) )
			return this.create_instance_command( $mol_wire_auto()! )
		}

		@ $mol_action
		create_instance_command( operation: object | string ) {
			const custom = this.widget().Custom()?.remote()
			if( custom?.source_format() === 'ts' ) {
				const pos = $mol_wire_sync( this ).instance_position()
				// Validate before any creation; asynchronous compilation must not duplicate widgets.
				this.map().runtime().components().component_class( custom.class_name() )
				return this.create_instance_apply( operation, custom.class_name(), pos )
			}
			const pos = $mol_wire_sync( this.Map_page() ).get_pointer_pos()
			return this.map().widget_add_batch( operation, ()=> $shm_hitalama_map_history.transaction( this.map(), 'Создание экземпляра старого компонента', ()=> {
				const widget = this.map().widget_add( 'custom', pos )
				widget?.Type_custom( null )?.remote( custom )
				return widget
			}) )
		}

		instance_position() {
			return [ this.widget().body_x() + this.widget().right_edge_x() + 40, this.widget().body_y() ]
		}

		@ $mol_action
		create_instance_apply( operation: object | string, fqn: string, pos: readonly number[] ) {
			return this.map().widget_add_batch( operation, ()=> $shm_hitalama_map_history.transaction( this.map(), 'Создание экземпляра компонента', ()=> {
				const code = this.map().widget_add( 'code_ts', pos, 500, 260, undefined,
					'const Component = $' + `component(${ JSON.stringify( fqn ) })\nreturn new Component()`, undefined, 'instance' )!
				code.title( 'Экземпляр ' + fqn )
				code.enabled( true )
				const view = this.map().widget_add( 'autoview', [ code.body_x() + 540, code.body_y() ], 600, 400, undefined, '', undefined, 'result' )!
				view.title( 'View: ' + code.title() )
				view.Use_text_from( null )!.remote( code )
				view.code_widget( code )
				code.view_widget( view )
				return view
			}) )
		}
		
	}
}
